// Admin Disputes endpoints.
//
// NOTHING HERE IS WIRED TO THE BACKEND YET. The contract these calls are written against is
// docs/temp/admin-disputes-backend-tz.md; the real request sits commented out above each
// mock, so switching over is uncommenting it, deleting the mock line, and adding:
//
//   import { request } from "../../../Services/Api"
//   import { normalizeListResponse, toQuery } from "../../DisputesPage/api/normalize"
//
// Paths follow this codebase's convention for an admin view over a domain resource: the
// domain app's own path, with the role widening the scope server-side (admin Alerts read
// /restful_api/alerts/list/filter, admin Receipts /user/requests/receipts/) — not
// /admin_panel/, which is reserved for the admin panel's own entities. BASE is the same
// prefix the merchant Recover module uses, so a change stays one line.
import { queryAdminDisputes, setMockPin } from "./mock.data"

const BASE = "/dispute-management"

export const ADMIN_DISPUTES_URL = `${BASE}/disputes/`

// apisauce shape, so the thunks read `response.ok` / `response.data` exactly as they will
// against the real endpoint.
const mockResponse = (data) => Promise.resolve({ ok: true, status: 200, data })

export const getAdminDisputes = (params) =>
  // request.api.get(ADMIN_DISPUTES_URL, toQuery(params)).then(normalizeListResponse)
  mockResponse(queryAdminDisputes(params))

export const pinAdminDispute = (id, pin) => {
  // return request.api.post(`${ADMIN_DISPUTES_URL}${id}/pin/`, { pin })
  setMockPin(id, pin)
  return mockResponse({ id, pinned: !!pin })
}

// Emailed, like every other admin export in this app: the response is a receipt, not a file.
export const getAdminDisputesExport = () =>
  // request.api.get(`${ADMIN_DISPUTES_URL}export/`, toQuery(params))
  mockResponse({ message: "Disputes report will be sent to your email shortly." })
